"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSPInjectionService = exports.EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS = exports.ATLASSIAN_IMAGES_HOSTS = void 0;
const types_1 = require("../types");
const ATLASSIAN_API_GATEWAY_HOST = {
    dev: 'https://api.dev.atlassian.com',
    stg: 'https://api.stg.atlassian.com',
    prod: 'https://api.atlassian.com',
    'fedramp-stg': 'https://api.stg.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://api.atlassian-us-gov-mod.com'
};
const ATLASSIAN_MEDIA_GATEWAY_HOST = {
    dev: 'https://media.dev.atl-paas.net',
    stg: 'https://media.staging.atl-paas.net',
    prod: 'https://api.media.atlassian.com',
    'fedramp-stg': 'https://api-media.stg.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://api-media.atlassian-us-gov-mod.com'
};
const ATLASSIAN_AVATAR_HOST = {
    dev: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
    stg: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
    prod: 'avatar-management--avatars.us-west-2.prod.public.atl-paas.net',
    'fedramp-stg': 'avatar-management--avatars.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
    'fedramp-prod': 'avatar-management--avatars.us-east-1.prod.cdn.atlassian-us-gov-mod.com'
};
const ATLASSIAN_EMOJIS_HOST = {
    dev: 'https://pf-emoji-service--cdn.ap-southeast-2.dev.public.atl-paas.net',
    stg: 'https://pf-emoji-service--cdn.us-east-1.staging.public.atl-paas.net',
    prod: 'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net',
    'fedramp-stg': 'https://pf-emoji-service--cdn.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://pf-emoji-service--cdn.us-east-1.prod.cdn.atlassian-us-gov-mod.com'
};
exports.ATLASSIAN_IMAGES_HOSTS = {
    dev: [
        `https://${ATLASSIAN_AVATAR_HOST['dev']}`,
        `https://*.wp.com/${ATLASSIAN_AVATAR_HOST['dev']}/`,
        ATLASSIAN_API_GATEWAY_HOST['dev'],
        ATLASSIAN_MEDIA_GATEWAY_HOST['dev'],
        ATLASSIAN_EMOJIS_HOST['dev']
    ],
    stg: [
        `https://${ATLASSIAN_AVATAR_HOST['stg']}`,
        `https://*.wp.com/${ATLASSIAN_AVATAR_HOST['stg']}/`,
        ATLASSIAN_API_GATEWAY_HOST['stg'],
        ATLASSIAN_MEDIA_GATEWAY_HOST['stg'],
        ATLASSIAN_EMOJIS_HOST['stg']
    ],
    prod: [
        `https://${ATLASSIAN_AVATAR_HOST['prod']}`,
        `https://*.wp.com/${ATLASSIAN_AVATAR_HOST['prod']}/`,
        ATLASSIAN_API_GATEWAY_HOST['prod'],
        ATLASSIAN_MEDIA_GATEWAY_HOST['prod'],
        ATLASSIAN_EMOJIS_HOST['prod']
    ],
    'fedramp-stg': [
        `https://${ATLASSIAN_AVATAR_HOST['fedramp-stg']}`,
        `https://*.wp.com/${ATLASSIAN_AVATAR_HOST['fedramp-stg']}/`,
        ATLASSIAN_API_GATEWAY_HOST['fedramp-stg'],
        ATLASSIAN_MEDIA_GATEWAY_HOST['fedramp-stg'],
        ATLASSIAN_EMOJIS_HOST['fedramp-stg']
    ],
    'fedramp-prod': [
        `https://${ATLASSIAN_AVATAR_HOST['fedramp-prod']}`,
        `https://*.wp.com/${ATLASSIAN_AVATAR_HOST['fedramp-prod']}/`,
        ATLASSIAN_API_GATEWAY_HOST['fedramp-prod'],
        ATLASSIAN_MEDIA_GATEWAY_HOST['fedramp-prod'],
        ATLASSIAN_EMOJIS_HOST['fedramp-prod']
    ]
};
exports.EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS = ['https://secure.gravatar.com', 'https://images.unsplash.com'];
class CSPInjectionService {
    getCSPReportUri(microsEnv) {
        if (microsEnv === 'dev' || microsEnv === 'stg')
            return 'https://web-security-reports.stg.services.atlassian.com/csp-report/forge-cdn';
        return 'https://web-security-reports.services.atlassian.com/csp-report/forge-cdn';
    }
    getForgeGlobalCSP(microsEnv, isFedRAMP = false) {
        return isFedRAMP
            ? `https://forge.cdn.${microsEnv.split('-')[1]}.atlassian-dev-us-gov-mod.net`
            : `https://forge.cdn.${microsEnv}.atlassian-dev.net`;
    }
    getExistingCSPDetails(cspType, cspDetails) {
        return cspDetails[cspType] ?? [];
    }
    getConnectSrc(microsEnv, isTunnelling) {
        const allowed = [];
        if (isTunnelling) {
            allowed.push(...['ws://localhost:*', 'http://localhost:*']);
        }
        allowed.push(`https://api.${microsEnv === 'prod' ? '' : 'stg.'}atlassian.com/metal/ingest`);
        return allowed;
    }
    getFrameAncestors(microsEnv, hostname) {
        let frameAncestors = [];
        if (microsEnv === 'dev' || microsEnv === 'stg') {
            frameAncestors = [
                '*.jira-dev.com',
                'http://localhost:*',
                '*.devbucket.org',
                'https://staging.bb-inf.net',
                'https://integration.bb-inf.net',
                '*.atl-paas.net',
                '*.stg.atlassian.com'
            ];
        }
        else if (microsEnv === 'fedramp-stg') {
            frameAncestors = ['*.atlassian-stg-fedm.net'];
        }
        else if (microsEnv === 'fedramp-prod') {
            frameAncestors = ['*.atlassian-us-gov-mod.net'];
        }
        else {
            frameAncestors = ['*.atlassian.net', 'bitbucket.org', '*.jira.com', '*.atlassian.com'];
        }
        if (hostname) {
            frameAncestors.push(hostname);
        }
        return frameAncestors;
    }
    getInjectableCSP = ({ existingCSPDetails, microsEnv, tunnelCSPReporterUri, hostname, isFedRAMP }) => {
        const reportUri = tunnelCSPReporterUri || this.getCSPReportUri(microsEnv);
        const defaultSrc = `'self'`;
        const frameAncestors = ["'self'", ...this.getFrameAncestors(microsEnv, hostname)].join(' ');
        const frameSrc = ["'self'", hostname, ...this.getExistingCSPDetails(types_1.ExternalCspType.FRAME_SRC, existingCSPDetails)]
            .filter((a) => a)
            .join(' ');
        const fontSrc = ["'self'", ...this.getExistingCSPDetails(types_1.ExternalCspType.FONT_SRC, existingCSPDetails)].join(' ');
        const imgSrc = [
            "'self'",
            'data:',
            'blob:',
            hostname,
            ...exports.EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS,
            ...exports.ATLASSIAN_IMAGES_HOSTS[microsEnv],
            ...this.getExistingCSPDetails(types_1.ExternalCspType.IMG_SRC, existingCSPDetails)
        ]
            .filter((a) => a)
            .join(' ');
        const mediaSrc = [
            "'self'",
            'data:',
            'blob:',
            hostname,
            ...this.getExistingCSPDetails(types_1.ExternalCspType.MEDIA_SRC, existingCSPDetails)
        ]
            .filter((a) => a)
            .join(' ');
        const connectSrc = [
            "'self'",
            ...this.getConnectSrc(microsEnv, !!tunnelCSPReporterUri),
            ...this.getExistingCSPDetails(types_1.ExternalCspType.CONNECT_SRC, existingCSPDetails)
        ].join(' ');
        const scriptSrc = [
            "'self'",
            this.getForgeGlobalCSP(microsEnv, isFedRAMP),
            ...this.getExistingCSPDetails(types_1.ExternalCspType.SCRIPT_SRC, existingCSPDetails)
        ].join(' ');
        const styleSrc = [
            "'self'",
            this.getForgeGlobalCSP(microsEnv, isFedRAMP),
            ...this.getExistingCSPDetails(types_1.ExternalCspType.STYLE_SRC, existingCSPDetails)
        ].join(' ');
        return [
            `default-src ${defaultSrc}`,
            `frame-ancestors ${frameAncestors}`,
            `frame-src ${frameSrc}`,
            `font-src ${fontSrc}`,
            `img-src ${imgSrc}`,
            `media-src ${mediaSrc}`,
            `connect-src ${connectSrc}`,
            `script-src ${scriptSrc}`,
            `style-src ${styleSrc}`,
            `form-action 'self'`,
            `sandbox allow-downloads allow-forms allow-modals allow-pointer-lock allow-same-origin allow-scripts`,
            `report-uri ${reportUri}`
        ];
    };
}
exports.CSPInjectionService = CSPInjectionService;
